import React from "react";
import { Breadcrumb } from "@gull";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import * as yup from "yup";
import { Dropdown, Modal, Table } from "react-bootstrap";
import queryString from "app/services/queryStringService";
import bookingService from "app/services/AdminServices/bookingService";
import { Helmet } from "react-helmet";
import { Button } from "react-bootstrap";
import { dateTimeFormat } from "config.json";
import moment from "moment";
import { FcApproval } from "react-icons/fc";
import { TiTimes } from "react-icons/ti";
import { Formik } from "formik";
import { NotificationManager } from "react-notifications";

export default function ApproveDetails({
  submitPassengerHandler,
  initialValues,
  validationSchema,
  approveDetailsShow,
  approveDetailsHandleCloses,
}) {
  return (
    <div>
      <Modal
        scrollable="inside"
        size="lg"
        show={approveDetailsShow}
        onHide={approveDetailsHandleCloses}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            <label className="text-dark text-bold">Change Request</label>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={submitPassengerHandler}
            enableReinitialize={true}
          >
            {({
              values,
              errors,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              isValid,
              dirty,
              setFieldValue,
            }) => {
              return (
                <form
                  className="needs-validation"
                  onSubmit={handleSubmit}
                  noValidate
                >
                  <div className="row">
                    <Table>
                      <thead style={{ textAlign: "center" }}>
                        <tr>
                          <th>Title</th>
                          <th>First Name</th>
                          <th>Last Name</th>
                          <th>Date of Birth</th>
                        </tr>
                      </thead>

                      {values.changePassengerList.map((item, index) => {
                        return (
                          <tbody key={index}>
                            <tr>
                              <td>
                                {" "}
                                <div className="custom-file">
                                  <select
                                    className="custom-select input-group input-group-sm"
                                    name={`changePassengerList[${index}].title`}
                                    id="inputGroupSelect01"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={
                                      values.changePassengerList[index]?.title
                                    }
                                  >
                                    <option value="Mr">Mr</option>
                                    <option value="Ms">Ms</option>
                                    <option value="Miss">Miss</option>
                                  </select>
                                </div>
                              </td>
                              <td>
                                <div className="row input-group input-group-sm  ">
                                  <input
                                    name={`changePassengerList[${index}].firstName`}
                                    value={
                                      values.changePassengerList[index]
                                        .firstName
                                    }
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    type="text"
                                    className="form-control "
                                    placeholder="First Name "
                                    aria-label="Username"
                                    aria-describedby="basic-addon1"
                                  />
                                </div>
                              </td>
                              <td>
                                {" "}
                                <div className="row input-group input-group-sm">
                                  <input
                                    name={`changePassengerList[${index}].lastName`}
                                    value={
                                      values.changePassengerList[index].lastName
                                    }
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    type="text"
                                    className="form-control input-group-sm"
                                    placeholder="Last Name"
                                    aria-label="Username"
                                    aria-describedby="basic-addon1"
                                  />
                                </div>
                              </td>
                              <td>
                                {" "}
                                <div className="row input-group input-group-md ">
                                  <input
                                    type="date"
                                    className="form-control"
                                    name={`changePassengerList[${index}].birthDate `}
                                    value={
                                      values.changePassengerList[index]
                                        .birthDate
                                        ? new moment(
                                            values.changePassengerList[
                                              index
                                            ].birthDate,
                                            "DD-YYYY-MM"
                                          ).format("YYYY-MM-DD")
                                        : ""
                                    }
                                    max={moment().format("YYYY-MM-DD")}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    aria-label="Username"
                                    aria-describedby="basic-addon1"
                                  />
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        );
                      })}
                    </Table>
                    <div className="row text-center mt-2 h-100 mr-12">
                      <div className="col h-100 text-center">
                        <Button
                          type="submit"
                          style={{ width: "20%", height: "100%" }}
                        >
                          Approve
                        </Button>
                      </div>
                    </div>
                  </div>
                </form>
              );
            }}
          </Formik>
        </Modal.Body>
      </Modal>
    </div>
  );
}
